import { Box, Typography } from "@mui/material";
import React from "react";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import IBanNumberInput from "./IBANNumberInput";
import CustomButton from "../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../media/images/icons/arrow-left-circle";
import CheckCircle from "../../../../../../media/images/icons/check-circle";

export default function BankAccountInfo() {
  return (
    <Box
      sx={{
        marginTop: "16px",
        width: "100%",
        backgroundColor: "background.default",
        padding: "16px",
        borderRadius: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "secondary.dark",
          fontSize: "16px",
        }}
      >
        ثبت مشخصات حساب بانکی{" "}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginTop: "16px",
        }}
      >
        <Box>
          <CustomInputLabel required>{"شماره شبا"}</CustomInputLabel>
          <IBanNumberInput />
        </Box>
        <Box>
          <CustomInputLabel>{"شماره حساب"}</CustomInputLabel>
          <CustomInput placHolder="شماره حساب را وارد کنید..." />
        </Box>
        <Box>
          <CustomInputLabel>{"شماره کارت"}</CustomInputLabel>
          <CustomInput placHolder="شماره کارت را وارد کنید..." />
        </Box>

        <CustomButton
          // loading={loading}
          // onClick={formik.handleSubmit}
          flexDirection="row"
          title="تکمیل پروفایل و بازگشت به پیشخوان"
          justifyContent="center"
          bgColor="success.main"
          width="100%"
          fSize="16px"
          fontWeight={600}
          px="10px"
          py="10px"
          borderRadius="10px"
          icon1={<CheckCircle size={32} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
